import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { history } from "../../redux-store/store";
function closeDropdown() {
    document.body.click();
}
const NavbarLink = props => {
    return (
        <Fragment>
            {history.location.pathname.startsWith("/app") ? (
                <Link {...props} onClick={closeDropdown}>
                    {props.label}
                </Link>
            ) : (
                <a href={props.to}>{props.label}</a>
            )}
        </Fragment>
    );
};

export default NavbarLink;